import { isEmptyFieldValue } from 'features/libra/ontology/ontologyFieldDefaults'
import type { FieldValue } from 'features/libra/ontology/ontologyFieldTypes'

/** True for nonempty human or legacy values that pre-fill must not replace. */
export function shouldPreserveValueOnPrefill(
  fieldValue: FieldValue | undefined
): boolean {
  return (
    fieldValue !== undefined &&
    !isEmptyFieldValue(fieldValue.value) &&
    (fieldValue.updateSource === 'human' ||
      fieldValue.updateSource === undefined)
  )
}
